import http from "../../utils/http"

/**
 * 登录
 */
export function login(params,type,sentType) {
    return http({
        url: "/auth/oauth2/token?grant_type=password&scope=server",
        method:'post',
        data: params,
        type:type,
        sentType:sentType
    })
}

/**
 * 退出登录
 */

 export function logout(params) {
    return http({
        url: "/auth/token/logout",
        method:'DELETE',
        data: params
    })
}

/**
 * 发送验证码
 */

 export function sendCode(params,hasId) {
     let url = hasId ? "/enterprise/register/sendCode/" + params.phone : "/enterprise/resetPwd/sendCode/" + params.phone
    return http({
        url: url,
        method:"get",
        data: params,
    })
}

/**
 * 忘记密码发送验证码
 */
//  export function resetSendCode(params) {
//     return http({
//         url: "/enterprise/resetPwd/sendCode/" + params.phone,
//         method:"get",
//         data: params,
//     })
// }
/**
 * 重置用户密码
 */
 export function resetPwd(params,sentType) {
    return http({
        url: "/enterprise/resetPwd",
        method:'put',
        data: params,
        sentType:sentType
    })
}

/**
 * 用户注册
 */

 export function register(params,sentType) {
    return http({
        url: "/enterprise/register",
        method:'post',
        data: params,
        sentType:sentType
    })
}


